export let mockData = function (module, keepOldMenu) {
    let i = 0;
    return [
        {
            title: "首页", color: "#d78635", icon: "shouye", link: "/home/preface",
        },
        {
            title: "消息提醒", color: "#7f72be", icon: "xiaoxi", type: 'common', link: "/home/message",
        },
        {
            module  : 1,
            title   : "物流", type: 'common', link: "/home/404#" + i++,code:'s_wuliu',
            children: [
                {
                    title: "询价记录",
                    color: "#FF5F78",
                    icon : "xunjiajilu",
                    link : "/home/commission/inquiryRecord"
                    ,
                    operations: [
                        'view',//查看
                        'remove',//删除
                    ]
                },
                {
                    title     : "报价单", color: "#e07660", icon: "baojiadan", link: "/home/order/quotation",
                    operations: [
                        'add',// 创建
                        'copy',// 复制
                        'toCommission',// 转委托单
                    ]
                },
                {
                    title   : "委托单管理", link: "/404#3",code:'s_wtdgl',
                    children: [
                        {
                            title     : "委托单", color: "#44CB80", icon: "weituodan", link: "/home/order/commission",code:'s_wtd',
                            operations: [
                                'add',// 创建
                                'copy',// 复制
                                'view',// 查看
                                'receive',// 接单
                                'unlock',// 解锁
                                'applyCancelCustomer',// 退关申请
                                'auditCancelCustomer',// 退关审核
                                'measureDataConfirm',// 测量数据确认
                                'edit',// 编辑
                                'discard',// 废弃
                            ]
                        },
                        {
                            title     : "费用明细",
                            code      :"s_fymx",
                            color     : "#FF522A",
                            icon      : "feiyongmingxi",
                            link      : "/home/commission/costDetail",
                            operations: [
                                'view',//查看
                                'edit',//编辑
                                'billUnlock',//发票解锁
                                'discard',//废弃
                                'confirm',//费用确认
                                'writeOffUnlock',//核销解锁
                                'restore',//恢复
                                'export',//导出
                                'exportAttachments',//导出图片/附件
                                'exportPrint',//打印
                            ]
                        },
                        {
                            title: "进仓信息",
                            color: "#36A7FF",
                            icon : "jincangxinxi",
                            link : "/home/commission/measurements"
                            ,
                            operations: [
                                'view',//查看测量数据
                                'submitMeasurements',//测量数据确认
                                'affirmMeasurements',//数据确认
                            ]
                        },
                        {
                            title     : "装货整柜",
                            color     : "#FF8002",
                            icon      : "zhuanghuozhenggui",
                            link      : "/home/commission/loadingFullContainer",
                            operations: [
                                'view',//查看
                                'edit',//编辑
                                'remove',//删除
                            ]
                        },
                        {
                            title     : "报关信息",
                            color     : "#7343DE",
                            icon      : "baoguanfuwu",
                            link      : "/home/commission/report",
                            operations: [
                                'edit',//编辑
                                'delete'//删除
                            ]
                        },
                        {
                            title: "提单信息",
                            color: "#FF4A66",
                            icon : "tidanxinxi",
                            link : "/home/commission/billInfo"
                            ,
                            operations: [
                                'view',//查看
                                'edit',//编辑
                                'remove',//删除
                            ]

                        },
                        {
                            title: "目的国申报",
                            color: "#40CA7D",
                            icon : "mudeguoshenbao",
                            link : "/home/commission/dstDeclaration"
                            ,
                            operations: [
                                'edit'//编辑
                            ]
                        },
                        {
                            title     : "清关信息",
                            color     : "#FF5D37",
                            icon      : "baoguanfuwu",
                            link      : "/home/commission/clearance",
                            operations: [
                                'edit',//编辑
                                'delete'//删除
                            ]
                        },
                        // {
                        //     title: "尾程订单", color: "#FF5D37", icon: "kuaisuzhongzhuan", link: "/home/commission/fastTransferOrder",
                        // },
                    ]
                },
            ]
        },
        {
            module  : 2,
            title   : "专线", type: 'common', link: "/home/404#" + i++,code:'s_zhuanxian',
            children: [
                {
                    title: "询价记录",
                    color: "#FF5F78",
                    icon : "xunjiajilu",
                    link : "/home/dedicatedLine/inquiryRecord"
                    ,
                    operations: [
                        'view',//查看
                        'remove',//删除
                    ]
                },
                {
                    title     : "报价单", color: "#e07660", icon: "baojiadan", link: "/home/dedicatedLine/quotation",
                    operations: [
                        'add',// 创建
                        'copy',// 复制
                        'toCommission',// 转委托单
                    ]
                },
                {
                    title   : "委托单管理", link: "/404#3",code:'s_zx_wtdgl',
                    children: [
                        {
                            title     : "委托单",
                            color     : "#44CB80",
                            icon      : "weituodan",
                            link      : "/home/dedicatedLine/commission",
                            code:'s_zx_wtd',
                            operations: [
                                'add',// 创建
                                'copy',// 复制
                                'view',// 查看
                                'receive',// 接单
                                'unlock',// 解锁
                                'applyCancelCustomer',// 退关申请
                                'auditCancelCustomer',// 退关审核
                                'measureDataConfirm',// 测量数据确认
                                'edit',// 编辑
                                'discard',// 废弃
                            ]
                        },
                        {
                            title     : "费用明细",
                            code      : "s_zx_wl_fymx",
                            color     : "#FF522A",
                            icon      : "feiyongmingxi",
                            link      : "/home/dedicatedLine/costDetail",
                            operations: [
                                'view',//查看
                                'edit',//编辑
                                'billUnlock',//发票解锁
                                'discard',//废弃
                                'confirm',//费用确认
                                'writeOffUnlock',//核销解锁
                                'restore',//恢复
                                'export',//导出
                                'exportAttachments',//导出图片/附件
                                'exportPrint',//打印
                            ]
                        },
                        {
                            title: "进仓信息",
                            color: "#36A7FF",
                            icon : "jincangxinxi",
                            link : "/home/dedicatedLine/measurements"
                            ,
                            operations: [
                                'view',//查看测量数据
                                'submitMeasurements',//测量数据确认
                                'affirmMeasurements',//数据确认
                            ]
                        },
                        {
                            title     : "报关信息",
                            color     : "#7343DE",
                            icon      : "baoguanfuwu",
                            link      : "/home/dedicatedLine/report",
                            operations: [
                                'edit',//编辑
                                'delete'//删除
                            ]
                        },
                        {
                            title: "提单信息",
                            color: "#FF4A66",
                            icon : "tidanxinxi",
                            link : "/home/dedicatedLine/billInfo"
                            ,
                            operations: [
                                'view',//查看
                                'edit',//编辑
                                'remove',//删除
                            ]

                        },
                        {
                            title     : "清关信息",
                            color     : "#FF5D37",
                            icon      : "baoguanfuwu",
                            link      : "/home/dedicatedLine/clearance",
                            operations: [
                                'edit',//编辑
                                'delete'//删除
                            ]
                        }
                    ]
                },
            ]
        },
        {
            module  : 3,
            title   : "尾程", type: 'common', link: "/home/404#" + i++,code:'s_wcdd',
            children: [
                {
                    title: "询价记录", color: "#FF5F78", icon: "xunjiajilu", link: "/home/wcOrder/inquiryRecord"
                },
                {
                    title: "报价单", color: "#40ca7d", icon: "kuaisuzhongzhuan", link: "/home/wcOrder/wcbjOrder",
                },
                {
                    title: "尾程订单", color: "#FF5D37", icon: "kuaisuzhongzhuan", link: "/home/wcOrder/order",
                },
                {
                    title: "清关信息", color: "#FF5D37", icon: "baoguanfuwu", link: "/home/wcOrder/qgxx",
                },
                {
                    title: "尾程派送订单",
                    color: "#FF8002",
                    icon : "zhongzhuanpaisongdingdan",
                    link : "/home/wcOrder/wcpsOrder"
                },
                {
                    title     : "尾程异常订单",
                    color     : "#FF522A",
                    icon      : "zhongzhuanpaisongdingdan",
                    link      : "/home/wcOrder/abnormal",
                    operations: []
                },
                keepOldMenu ? {
                    title: "尾程订单（旧）",
                    color: "#FF5D37",
                    icon : "kuaisuzhongzhuan",
                    link : "/home/commission/fastTransferOrder",
                } : null,
                keepOldMenu ? {
                    title: "尾程派送订单（旧）",
                    color: "#FF8002",
                    icon : "zhongzhuanpaisongdingdan",
                    link : "/home/commission/deliveryTransferOrder"
                } : null,
                keepOldMenu ? {
                    title     : "尾程异常订单（旧）",
                    color     : "#FF522A",
                    icon      : "zhongzhuanpaisongdingdan",
                    link      : "/home/commission/abnormalOrder",
                    operations: []
                } : null,
                {
                    title     : "费用明细",
                    code      :  "s_zz_fymx",
                    color     : "#FF522A",
                    icon      : "feiyongmingxi",
                    link      : "/home/fastTransferOrder/commission/costDetail",
                    operations: []
                },
            ].filter(e => e)
        },
        {title: "海外仓", module: 4, color: "#fd532d", icon: "yewuguanli", link: "/404#4"},

    ].filter(e => {
        if (e.module != null) {
            // console.log({e:e.title,eM:e.module,module})
            return (module & (1 << e.module)) > 0;
        }
        return true;
    });
};

export const settingMenu = {
    title   : "设置", link: "/404#5",
    children: [
        {
            title       : "公司信息", color: "#36A7FF", icon: "gongsi", link: "/home/setting/company"
            , operations: ['add',//新增
            ]
        },
        {
            title     : "账号管理", color: "#40CA7D", icon: "zhanghaoguanli", link: "/home/setting/account",
            operations: ['add', 'edit', 'view', 'enable', 'disable', 'updatePassword']
        },
    ]
};
// 自动生成 sql
/*
let toSql = (menu) => {
    let sqlList = [];
    let funcSqlList = [];
    let mnTemplate = mn =>
`insert into bc_menu(id, create_by, create_name, create_date, modify_by, modify_name, modify_date, version,is_del, menu_code,menu_name, color, icon,url,parent_id,app_code,app_id,type)
values('${mn.id}','admin','系统管理员',now(),'admin','系统管理员',now(),1,0,'${mn.code||""}','${mn.title}','','${mn.icon}','${mn.link}','${mn.parentId||""}','SERVICE','SERVICE','${mn.type||""}');
`;
    let optTemplate = opt =>
`insert into bc_function(id, create_by, create_name, create_date, modify_by, modify_name, modify_date, version,is_del, func_code,func_name,menu_id)
values('${opt.id}','admin','系统管理员',now(),'admin','系统管理员',now(),1,0,'${opt.code}','','${opt.menuId}');
`;
    let mnSql = mn=>{
        mn.id = util.id();
        sqlList.push(mnTemplate(mn));
        if(mn.operations){
            mn.operations.forEach(opt => funcSqlList.push(optTemplate({
                id: util.id(),
                menuId: mn.id,
                code: opt
            })));
        }
        if(mn.children){
            mn.children.forEach(_mn => {
                _mn.parentId = mn.id;
                mnSql(_mn);
            });
        }
    }
    menu.forEach(mn => mnSql(mn));
    console.log([...sqlList,...funcSqlList].join(""));
}
console.log('---------------------')
toSql(mockData);
console.log('---------------------')
*/



// WEBPACK FOOTER //
// ./src/common/menuMockData.js